enum LogType {
    Info = 'Info',
    Error = 'Error',
    Warn = 'Warn'
}

export default LogType;